
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiConnection3BarsCaution as ObiConnection3BarsCautionElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-connection-3-bars-caution.js';
 
 
 

 
 export const ObiConnection3BarsCaution = createComponent({
   react: React,
   tagName: 'obi-connection-3-bars-caution',
   elementClass: ObiConnection3BarsCautionElement,
   events: {
     
   }
  });
 
 